<template>
    <div id="app" class="app">
<!--        <van-notice-bar scrollable text="春节放假啦，感谢大家的支持，初八开工！" background="#ff0000" color="#ffffff"/>-->
        <app-header
                :title="$route.meta.title"
                :hideNavIcon="!navShow"
                :hideBackIcon="!backShow"
                @go-back="handleGoBack"
                v-show="!$route.meta.hideHeader && $store.state.headerShow"></app-header>
        <keep-alive>
            <router-view class="app-body" v-if="$route.meta.keepAlive"/>
        </keep-alive>

        <router-view class="app-body" v-if="!$route.meta.keepAlive"/>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "App",
        components: {
            AppHeader: () => import('@/components/common/header/Header')
        },
        created() {
            document.body.addEventListener('focusout', () => {
                //软键盘收起的事件处理
                let ua = window.navigator.userAgent;
                let app = window.navigator.appVersion;
                //$alert('浏览器版本: ' + app + '\n' + '用户代理: ' + ua);
                if (!!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
                    //$alert('ios端');
                    let currentPosition, timer;
                    let speed = 1;
                    timer = setInterval(function () {
                        currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
                        currentPosition -= speed;
                        window.scrollTo(0, currentPosition); //页面向上滚动
                        currentPosition += speed;
                        window.scrollTo(0, currentPosition); //页面向下滚动
                        clearInterval(timer);
                    }, 100);
                } else if (ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1) {
                    //$alert('android端');
                }
            });
            if (/Android/gi.test(navigator.userAgent)) {
                window.addEventListener('resize', function () {
                    if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
                        window.setTimeout(function () {
                            document.activeElement.scrollIntoViewIfNeeded();
                        }, 0);
                    }
                })
            } else {
                window.scrollTo(0, document.documentElement.scrollTop || document.body.scrollTop)
            }
            window.onresize = () => {
                document.querySelector('html').style.height = window.innerHeight + 'px';
            }
            console.log(this.$route)
            if (this.$store.state.token) {
                let params = {
                    params: "TRANSPORT_WAY"
                };
                this.$axios.post("dict/info", params).then(res => {
                    if (res.data.code === 200) {
                        let d = res.data.data;
                        d.forEach(val => {
                            val.name = val.dictName;
                        });
                        this.$store.commit({
                            type: "getDict",
                            t: "transport",
                            list: d
                        });
                    }
                });
                params = {
                    params: "PACK_NAME_TYPE"
                };
                this.$axios.post("dict/info", params).then(res => {
                    if (res.data.code === 200) {
                        let d = res.data.data;
                        d.forEach(val => {
                            val.name = val.dictName;
                        });
                        this.$store.commit({
                            type: "getDict",
                            t: "pack",
                            list: d
                        });
                    }
                });
                params = {
                    params: "PAY_MEANS_TYPE"
                };
                this.$axios.post("dict/info", params).then(res => {
                    if (res.data.code === 200) {
                        let d = res.data.data;
                        d.forEach(val => {
                            val.name = val.dictName;
                        });
                        this.$store.commit({
                            type: "getDict",
                            t: "pay",
                            list: d
                        });
                    }
                });
                params = {
                    params: "DELIVERY_TYPE"
                };
                this.$axios.post("dict/info", params).then(res => {
                    if (res.data.code === 200) {
                        let d = res.data.data;
                        d.forEach(val => {
                            val.name = val.dictName;
                        });
                        this.$store.commit({
                            type: "getDict",
                            t: "delivery",
                            list: d
                        });
                    }
                });
                params = {
                    params: "TRACKING_STATUS"
                };
                this.$axios.post("dict/info", params).then(res => {
                    if (res.data.code === 200) {
                        let d = res.data.data;
                        d.forEach(val => {
                            val.name = val.dictName;
                        });
                        this.$store.commit({
                            type: "getDict",
                            t: "status",
                            list: d
                        });
                    }
                });
            }
        },
        methods: {
            handleGoBack() {
                this.$router.go(-1);
            },
        },
        computed: mapState({
            title: state => state.title,
            navShow: state => !state.hideNav,
            backShow: state => !state.hideBack
        })
    };
</script>

<style lang="scss">
    /*******************   初始化代码   ***************************/
    html, body {
        height: 100%;
    }

    html,
    body,
    ul,
    li,
    div,
    p,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        margin: 0;
        padding: 0;
        font-weight: normal;
    }

    ul,
    li {
        list-style: none;
    }

    a,
    i {
        color: #000;
        text-decoration: none;
        font-style: normal;
    }

    input {
        border: 0;
        outline: 0;
        line-height: 100%;

        &::-webkit-input-placeholder {
            line-height: 1.3
        }
    }

    /**************************  公共样式  *****************************/
    .layout-box {
        background-color: #fff;

        & ~ .layout-box {
            margin-top: 0.13rem;
        }
    }

    .popup-header {
        width: 100%;
        height: 1.17rem;
        box-sizing: border-box;
        position: relative;

        &-title {
            padding-left: 0.4rem;
            font-size: 0.4rem;
            height: 1.17rem;
            line-height: 1.17rem;
            font-weight: normal;
            position: relative;
            border-bottom: 1px solid #e5e5e5;
        }

        &-icon {
            position: absolute;
            right: 0.4rem;
            top: 50%;
            transform: translateY(-50%);
        }
    }

    .popup-section {
        .section-header {
            font-size: 0.39rem;
            font-weight: 600;
            padding: 0.67rem 0.59rem 0.2rem;
        }
    }

    .f-tip {
        color: #8f8f8f;
    }

    .line {
        border: 1px solid #e5e5e5;
    }

    .line-top {
        border-top: 1px solid #e5e5e5;
    }

    .line-bottom {
        border-bottom: 1px solid #e5e5e5;
    }

    .line-left {
        border-left: 1px solid #e5e5e5;
    }

    .line-right {
        border-right: 1px solid #e5e5e5;
    }

    .btn-spacing-4 {
        letter-spacing: 0.4rem;
    }

    /*************************   APP代码   *******************************/

    .app {
        font-family: Helvetica Neue, Helvetica, Microsoft YaHei;
        display: flex;
        flex-direction: column;
        height: 100%;

        .app-header {
            background-color: #042D6F;
            color: #fff;
            width: 100%;
            height: 1.17rem;
            padding: 0 0.25rem;
            box-sizing: border-box;
            position: relative;
        }

        .back-icon {
            position: absolute;
            left: 0.59rem;
            top: 50%;
            transform: translateY(-50%);
        }

        .app-header-title {
            height: 100%;
            line-height: 1.17rem;
            font-size: 0.45rem;
            text-align: center;
            font-weight: normal;
        }

        .menu-icon {
            height: 0.55rem;
            width: 0.61rem;
            position: absolute;
            right: 0.59rem;
            top: 50%;
            transform: translateY(-50%);
        }

        .body-padding {
            padding: 0.08rem 0.27rem;
        }

        .app-body {
            flex: 1;
            overflow-y: hidden;
            background-color: #e5e5e5;

            &::-webkit-scrollbar {
                width: 0;
                height: 0;
                background-color: transparent;
            }
        }

        .app-footer {
            height: 0.91rem;
            width: 100%;
            background-color: #042D6F;
        }
    }


    /************************  导航菜单  ********************/
    .nav-overlay {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 998;
        background-color: transparent;
    }

    .nav-content {
        position: absolute;
        top: 1.17rem;
        right: 0;
        background: #37363c;
        text-align: center;
        padding: 0.2rem;
        font-size: 0.3rem;
        z-index: 999;

        li {
            border-bottom: 1px solid #57565b;
            padding-bottom: 0.2rem;
            margin-bottom: 0.2rem;

            a {
                color: #fff;

                img {
                    width: 0.5rem;
                }
            }

            &:last-child {
                padding-bottom: 0;
                margin-bottom: 0;
                border: 0;
            }
        }
    }

    .van-button--warning {
        height: 0.96rem;
        line-height: 0.96rem;
        width: 100%;

        &[disabled] {
            color: #ffffff;
            background: #BFBFBF;
            border: 0;
        }
    }

    .van-icon {
        color: #000;
    }

    .van-dialog__message {
        text-align: center;
    }

    /**=======================字体大小===================*/
    .font56 {
        font-size: 0.56rem;
    }

    .font48 {
        font-size: 0.48rem;
    }

    .font43 {
        font-size: 0.43rem;
    }

    .font40 {
        font-size: 0.40rem;
    }

    .font37 {
        font-size: 0.37rem;
    }

    .font35 {
        font-size: 0.35rem;
    }

    .font32 {
        font-size: 0.32rem;
    }

    .font27 {
        font-size: 0.27rem;
    }

    /**=======================字体颜色===================*/
    .color-white {
        color: #fff;
    }

    .color-default {
        color: #4F4F4F;
    }

    .color-2F {
        color: #2F2F2F;
    }

    .color-2D {
        color: #2D2D2D;
    }

    .color-4F {
        color: #4F4F4F;
    }

    .color-8F {
        color: #8F8F8F;
    }

    .color-orange {
        color: #FE9329;
    }

    .color-red {
        color: #E82222;
    }

    .color-primary {
        color: #042D6F;
    }
</style>
